import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';
import styles from './AuthLayout.module.css';

const BRAND_LOGO_DARK = '/logos/logo-alta-preta.png?v=20260520';
const BRAND_LOGO_LIGHT = '/logos/logo-alta-branca.png?v=20260520';

const AuthLayout = () => {
  const { t } = useTranslation();
  const { user, loading } = useAuth();
  const location = useLocation();
  const split = location.pathname === '/login' || location.pathname === '/register';
  const login = location.pathname === '/login';

  if (loading) return null;
  if (user) return <Navigate to="/dashboard" replace />;

  if (!split) {
    return (
      <main className="flex min-h-screen items-center justify-center bg-slate-50 px-4 py-10 text-slate-900">
        <div className="w-full max-w-md">
          <Brand className="mb-8 justify-center" />
          <Outlet />
        </div>
      </main>
    );
  }

  return (
    <main className={`${styles.authRoot} ${login ? styles.loginRoot : ''} grid bg-slate-50 text-slate-900 lg:grid-cols-2`}>
      <section className="hidden items-center justify-center bg-gradient-to-br from-[#111827] to-[#3b4758] px-10 text-center text-white lg:flex">
        <div className="max-w-xl">
          <div className="mx-auto mb-9 flex h-auto w-fit items-center justify-center">
            <img src={BRAND_LOGO_LIGHT} alt="Clarity Files" className="h-[108px] max-w-full object-contain" />
          </div>
          <h1 className="text-4xl font-bold tracking-tight">
            {t('authSplit.titleBefore')} <span className="text-sky-400">ClarityFiles</span>.
          </h1>
          <p className="mt-5 text-xl leading-8 text-slate-200">
            {t('authSplit.subtitle')}
          </p>
        </div>
      </section>

      <section className={`${login ? styles.loginPane : ''} flex items-center justify-center px-4 py-10`}>
        <div className={`${login ? styles.loginCard : ''} w-full max-w-md rounded-lg border border-slate-200 bg-white p-8 shadow-soft`}>
          {login && <Brand className={`${styles.mobileBrand} mb-5 justify-center lg:hidden`} />}
          <Outlet />
        </div>
      </section>
    </main>
  );
};

export const Brand = ({ className = '' }) => (
  <div className={`flex items-center gap-3 ${className}`}>
    <img src={BRAND_LOGO_DARK} alt="Clarity Files" className="h-[72px] max-w-full object-contain" />
  </div>
);

export default AuthLayout;
